import React, { useState, useMemo } from "react";
import { useUserAuth } from "../../context/UserAuthContext";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaCalendarAlt,
  FaUser,
  FaTag,
  FaClock,
  FaChartLine,
  FaRupeeSign,
  FaMapMarkerAlt,
  FaSpinner,
  FaTachometerAlt,
  FaClipboardList,
  FaFire,
  FaSnowflake,
  FaSun,
  FaCheckCircle,
  FaTimes, 
  FaCrown,
  FaStar,
  FaGem,
  FaArrowRight, 
  FaEye,
  FaFilePdf,
} from "react-icons/fa";
import { Link } from "react-router-dom"; 
import { Modal } from "react-bootstrap";
 
 
import DestinationWeddingQuotationPdf from "../quotation/DestinationWeddingQuotationPdf";
import InternationalWeddingQuotationPdf from "../quotation/InternationalWeddingQuotationPdf";

 

import WeddingQuotationPDF from "../quotation/WeddingQuotationPDF";
import BirthdayQuotation from "../quotation/BirthdayQuotation";
import CorporateQuotation from "../quotation/CorporateQuotation";
import AnniversaryQuotation from "../quotation/AnniversaryQuotation";
 

const FONT = "'DM Sans', 'Poppins', 'Segoe UI', sans-serif";

const C = {
  bg: "#f0f4f9",
  surface: "#ffffff",
  border: "#e8edf4",
  text: "#0f1c2e",
  muted: "#64748b",
  accent: "#2563EB",
  accentBg: "#EBF4FF",
  pill: "#f1f5f9",
  success: "#10b981",
  danger: "#ef4444",
  warning: "#f59e0b",
  info: "#6366f1",
  gold: "#d4a853",
};

const pill = (bg, color, border = "transparent") => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 3,
  padding: "3px 9px",
  borderRadius: 16,
  fontSize: 10,
  fontWeight: 600,
  background: bg,
  color,
  border: `1px solid ${border}`,
  whiteSpace: "nowrap",
  letterSpacing: "0.2px",
});

const STATUS_CFG = {
  open: {
    bg: "linear-gradient(135deg, #ecfdf5, #d1fae5)",
    color: "#065f46",
    border: "#6ee7b7",
    icon: <FaCheckCircle size={9} />,
  },
  close: {
    bg: "linear-gradient(135deg, #fef2f2, #fee2e2)",
    color: "#991b1b",
    border: "#fca5a5",
    icon: <FaTimes size={9} />,
  },
  pending: {
    bg: "linear-gradient(135deg, #fffbeb, #fef3c7)",
    color: "#92400e",
    border: "#fcd34d",
    icon: <FaSpinner size={9} />,
  },
};

const LABEL_CFG = {
  hot: {
    bg: "linear-gradient(135deg, #fff1f2, #ffe4e6)",
    color: "#be123c",
    icon: <FaFire size={9} />,
  },
  warm: {
    bg: "linear-gradient(135deg, #fff7ed, #ffedd5)",
    color: "#c2410c",
    icon: <FaSun size={9} />,
  },
  cold: {
    bg: "linear-gradient(135deg, #eff6ff, #dbeafe)",
    color: "#1e40af",
    icon: <FaSnowflake size={9} />,
  },
};

const STAGE_CONFIG = {
  negotiation: { color: "#f59e0b", icon: "⚡", label: "Negotiation" },
  proposal_shared: { color: "#3b82f6", icon: "📋", label: "Proposal Shared" },
  converted: { color: "#10b981", icon: "✅", label: "Converted" },
  not_converted: { color: "#ef4444", icon: "💀", label: "Dead" },
  enquiry: { color: "#6366f1", icon: "🔍", label: "Enquiry" },
  follow_up: { color: "#8b5cf6", icon: "📞", label: "Follow Up" },
};

const statusCfg = (s = "") =>
  STATUS_CFG[s?.toLowerCase()] || {
    bg: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
    color: "#475569",
    border: "#e2e8f0",
    icon: <FaTag size={9} />,
  };

const labelCfg = (l = "") =>
  LABEL_CFG[l?.toLowerCase()] || {
    bg: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
    color: "#475569",
    icon: <FaTag size={9} />,
  };

const LeadCard = ({ item, onCall, onWhatsapp }) => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const { user, token } = useUserAuth();
  const user_id = user?.uid;

  const [hovered, setHovered] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [showDealModal, setShowDealModal] = useState(false);

  const sc = statusCfg(item?.status);
  const lc = labelCfg(item?.lead_label);
  const stageInfo = STAGE_CONFIG[item?.stage_key] || {};

  // Check if lead is dead (stage_key = not_converted)
  const isDeadLead = useMemo(() => {
    return item?.stage_key === "not_converted";
  }, [item?.stage_key]);

  // Check if lead is converted (won)
  const isWon = useMemo(() => {
    return item?.stage_key === "converted" || item?.progress === 100;
  }, [item?.stage_key, item?.progress]);

  // Check if followup is overdue (only if not converted/dead)
  const isOverdueFollowup = useMemo(() => {
    if (
      item?.stage_key === "converted" ||
      item?.stage_key === "not_converted"
    ) {
      return false;
    }
    if (!item?.followup_date_time) return false;
    return new Date() > new Date(item.followup_date_time);
  }, [item?.stage_key, item?.followup_date_time]);

  const isQuotationType = [
    "wedding_quotation",
    "birthday_quotation",
    "anniversary_quotation",
    "corporate_quotations",
    "destination_wedding_quotation",
    "international_wedding_quotation",
  ].includes(item?.lead_type);

  const hasPriceInfo =
    item?.price_info && Object.keys(item?.price_info).length > 0;
  const hasDealPrice = item?.price_info?.deal_close_price != null;

  const handleClosePdf = () => setShowPdf(false);

  const renderPdfComponent = () => {
    if (!item) return null;
    switch (item.lead_type) {
      case "wedding_quotation":
        return (
          <WeddingQuotationPDF
            pdfData={{
              quotation_details: item?.quotation_details,
              mob_no_status: item?.price_info?.mob_no_status,
            }}
          />
        );
      case "destination_wedding_quotation":
        return (
          <DestinationWeddingQuotationPdf
            pdfData={{
              quotation_details: item?.quotation_details,
              mob_no_status: item?.price_info?.mob_no_status,
            }}
          />
        );
      case "international_wedding_quotation":
        return (
          <InternationalWeddingQuotationPdf
            pdfData={{
              quotation_details: item?.quotation_details,
              mob_no_status: item?.price_info?.mob_no_status,
            }}
          />
        );
      case "birthday_quotation":
        return (
          <BirthdayQuotation
            pdfData={{
              quotation_details: item?.quotation_details,
              mob_no_status: item?.price_info?.mob_no_status,
            }}
          />
        );
      case "corporate_quotations":
        return (
          <CorporateQuotation
            pdfData={{
              quotation_details: item?.quotation_details,
              mob_no_status: item?.price_info?.mob_no_status,
            }}
          />
        );
      case "anniversary_quotation":
        return (
          <AnniversaryQuotation
            pdfData={{
              quotation_details: item?.quotation_details,
              mob_no_status: item?.price_info?.mob_no_status,
            }}
          />
        );
      default:
        return <div className="text-danger p-3">Unknown quotation type</div>;
    }
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    let dateObj;
    if (!isNaN(date) && String(date).length >= 10) {
      dateObj = new Date(Number(date) * 1000);
    } else {
      dateObj = new Date(date);
    }
    return dateObj.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDateTime = (date) => {
    if (!date) return "N/A";
    let dateObj;
    if (!isNaN(date) && String(date).length >= 10) {
      dateObj = new Date(Number(date) * 1000);
    } else {
      dateObj = new Date(date);
    }
    return dateObj.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatCurrency = (amount) => {
    if (!amount) return null;
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Card theme based on state
  const getCardTheme = () => {
    if (isDeadLead) {
      return {
        background: "linear-gradient(145deg, #1a1a2e, #16213e)",
        border: "1px solid #2a1a1a",
        textColor: "#cbd5e1",
        mutedColor: "#64748b",
        shadow: "0 4px 16px rgba(239, 68, 68, 0.12)",
        accentBorder: "#ef4444",
        footerBg: "rgba(0,0,0,0.2)",
        headerBg: "rgba(0,0,0,0.15)",
      };
    }
    if (isOverdueFollowup) {
      return {
        background: "linear-gradient(145deg, #fff5f5, #fee2e2)",
        border: "1px solid #fecaca",
        textColor: "#1a1a2e",
        mutedColor: "#64748b",
        shadow: "0 4px 16px rgba(239, 68, 68, 0.08)",
        accentBorder: "#ef4444",
        footerBg: "rgba(239, 68, 68, 0.03)",
        headerBg: "rgba(239, 68, 68, 0.03)",
      };
    }
    if (isWon) {
      return {
        background: "linear-gradient(145deg, #ffffff, #f0fdf4)",
        border: "1px solid #bbf7d0",
        textColor: C.text,
        mutedColor: C.muted,
        shadow: "0 4px 16px rgba(16, 185, 129, 0.1)",
        accentBorder: "#10b981",
        footerBg: "rgba(16, 185, 129, 0.02)",
        headerBg: "rgba(16, 185, 129, 0.02)",
      };
    }
    return {
      background: C.surface,
      border: `1px solid ${C.border}`,
      textColor: C.text,
      mutedColor: C.muted,
      shadow: "0 2px 8px rgba(0,0,0,0.04)",
      accentBorder: C.accent,
      footerBg: "#fafcff",
      headerBg: "transparent",
    };
  };

  const theme = getCardTheme();

  return (
    <>
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          background: theme.background,
          border: `1.5px solid ${hovered ? theme.accentBorder : theme.border}`,
          borderRadius: 16,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          transform: hovered ? "translateY(-3px)" : "none",
          boxShadow: hovered
            ? `0 12px 28px -8px rgba(0,0,0,0.15)`
            : theme.shadow,
          transition: "all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1.2)",
          position: "relative",
          maxWidth: "100%",
        }}
      >
        {/* DEAD Ribbon */}
        {isDeadLead && (
          <div
            style={{
              position: "absolute",
              top: 10,
              right: -28,
              transform: "rotate(45deg)",
              background: "linear-gradient(135deg, #ef4444, #dc2626)",
              color: "#fff",
              padding: "3px 32px",
              fontSize: 9,
              fontWeight: 800,
              letterSpacing: "1px",
              zIndex: 2,
              boxShadow: "0 2px 6px rgba(239, 68, 68, 0.3)",
            }}
          >
            DEAD
          </div>
        )}

        {/* OVERDUE Ribbon - only if not dead and not converted */}
        {!isDeadLead && !isWon && isOverdueFollowup && (
          <div
            style={{
              position: "absolute",
              top: 10,
              right: -28,
              transform: "rotate(45deg)",
              background: "linear-gradient(135deg, #f59e0b, #d97706)",
              color: "#fff",
              padding: "3px 32px",
              fontSize: 9,
              fontWeight: 800,
              letterSpacing: "1px",
              zIndex: 2,
              boxShadow: "0 2px 6px rgba(245, 158, 11, 0.3)",
            }}
          >
            OVERDUE
          </div>
        )}

        {/* WON Ribbon */}
        {isWon && (
          <div
            style={{
              position: "absolute",
              top: 10,
              right: -28,
              transform: "rotate(45deg)",
              background: "linear-gradient(135deg, #10b981, #059669)",
              color: "#fff",
              padding: "3px 32px",
              fontSize: 9,
              fontWeight: 800,
              letterSpacing: "1px",
              zIndex: 2,
              boxShadow: "0 2px 6px rgba(16, 185, 129, 0.3)",
            }}
          >
            Converted
          </div>
        )}

        {/* Top Gradient Bar */}
        <div
          style={{
            height: 3,
            background: isDeadLead
              ? "linear-gradient(90deg, #991b1b, #ef4444)"
              : isOverdueFollowup
                ? "linear-gradient(90deg, #f59e0b, #ef4444)"
                : isWon
                  ? "linear-gradient(90deg, #059669, #10b981)"
                  : item?.lead_label?.toLowerCase() === "hot"
                    ? "linear-gradient(90deg, #f59e0b, #ef4444)"
                    : item?.lead_label?.toLowerCase() === "cold"
                      ? "linear-gradient(90deg, #60a5fa, #3b82f6)"
                      : "linear-gradient(90deg, #34d399, #10b981)",
          }}
        />

        {/* HEADER - Compact */}
        <div
          style={{
            padding: "12px 14px 10px",
            borderBottom: `1px solid ${isDeadLead || isOverdueFollowup ? "rgba(0,0,0,0.06)" : C.border}`,
            background: theme.headerBg,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 8,
            }}
          >
            <div style={{ flex: 1, minWidth: 0, marginRight: 6 }}>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: theme.textColor,
                  marginBottom: 6,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                {isWon && <FaCrown size={12} style={{ color: C.gold }} />}
                {item?.lead_name}

                {/* ── View Quotation Button - Right side of name ── */}
              </div>
              <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                <span style={pill(sc.bg, sc.color, sc.border)}>
                  {sc.icon} {item?.status || "Open"}
                </span>
                {item?.lead_label && (
                  <span style={pill(lc.bg, lc.color)}>
                    {lc.icon} {item?.lead_label}
                  </span>
                )}
                {stageInfo.icon && (
                  <span
                    style={pill(
                      `${stageInfo.color}15`,
                      stageInfo.color,
                      `${stageInfo.color}30`,
                    )}
                  >
                    {stageInfo.icon} {stageInfo.label}
                  </span>
                )}
              </div>
            </div>

            {/* Progress Circle - Smaller */}
            {item?.progress != null && (
              <div
                style={{
                  position: "relative",
                  width: 40,
                  height: 40,
                  flexShrink: 0,
                }}
              >
                <svg width="40" height="40" viewBox="0 0 40 40">
                  <circle
                    cx="20"
                    cy="20"
                    r="17"
                    fill="none"
                    stroke={
                      isDeadLead || isOverdueFollowup ? "#e5e7eb" : "#e5e7eb"
                    }
                    strokeWidth="3"
                  />
                  <circle
                    cx="20"
                    cy="20"
                    r="17"
                    fill="none"
                    stroke={
                      isDeadLead
                        ? "#ef4444"
                        : isOverdueFollowup
                          ? "#f59e0b"
                          : isWon
                            ? "#10b981"
                            : item.progress > 50
                              ? C.accent
                              : C.warning
                    }
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray={`${(item.progress / 100) * 106.8} 106.8`}
                    transform="rotate(-90 20 20)"
                    style={{ transition: "stroke-dasharray 0.4s ease" }}
                  />
                </svg>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: 10,
                    fontWeight: 700,
                    color: theme.textColor,
                  }}
                >
                  {item.progress}%
                </div>
              </div>
            )}
          </div>

          {/* Quick Info Row */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              color: theme.mutedColor,
              fontSize: 11,
              flexWrap: "wrap",
            }}
          >
            {item?.name && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                <FaUser size={11} style={{ color: C.gold }} />
                <span style={{ fontWeight: 600, color: theme.textColor }}>
                  {item.name}
                </span>
              </div>
            )}
            {isQuotationType && (
              <button
                onClick={() => setShowPdf(true)}
                title="View Quotation PDF"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 3,
                  padding: "2px 8px",
                  borderRadius: 12,
                  border: `1px solid ${C.accent}30`,
                  background: C.accentBg,
                  color: C.accent,
                  fontWeight: 600,
                  fontSize: 9,
                  cursor: "pointer",
                  fontFamily: FONT,
                  transition: "all 0.15s",
                  marginLeft: 6,
                  flexShrink: 0,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = C.accent;
                  e.currentTarget.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = C.accentBg;
                  e.currentTarget.style.color = C.accent;
                }}
              >
                <FaFilePdf size={9} /> QT
              </button>
            )}
            {hasDealPrice && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  color: C.gold,
                  fontWeight: 600,
                  background: "rgba(212, 168, 83, 0.1)",
                  padding: "2px 7px",
                  borderRadius: 10,
                  fontSize: 10,
                }}
              >
                <FaGem size={9} />
                {formatCurrency(item.price_info.deal_close_price)}
              </span>
            )}
          </div>
        </div>

        {/* BODY - Compact */}
        <div style={{ padding: "10px 14px", flex: 1 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "8px 6px",
            }}
          >
            {[
              {
                icon: <FaTag size={10} />,
                color: C.warning,
                label: "Event",
                value: item?.event_type || "N/A",
              },
              {
                icon: <FaCalendarAlt size={10} />,
                color: C.info,
                label: "Date",
                value: formatDate(item?.event_date),
              },
              {
                icon: <FaChartLine size={10} />,
                color: "#ec4899",
                label: "Status",
                value: item?.lead_status || item?.stage_name || "—",
              },
              {
                icon: <FaClock size={10} />,
                color: theme.mutedColor,
                label: "Created",
                value: formatDateTime(item?.created_at),
              },
            ].map((row, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 6,
                  padding: "4px 6px",
                  borderRadius: 8,
                }}
              >
                <div
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: 6,
                    background: `${row.color}15`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: row.color,
                    flexShrink: 0,
                    marginTop: 1,
                  }}
                >
                  {row.icon}
                </div>
                <div style={{ minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 9,
                      color: theme.mutedColor,
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {row.label}
                  </div>
                  <div
                    style={{
                      fontSize: 11.5,
                      fontWeight: 600,
                      color: theme.textColor,
                      marginTop: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.value}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* City & Follow-up */}
          <div
            style={{
              marginTop: 8,
              display: "flex",
              gap: 6,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {item?.city_name && (
              <span
                style={{
                  ...pill(
                    isDeadLead
                      ? "#2a2a4e"
                      : isOverdueFollowup
                        ? "#fee2e2"
                        : "#f1f5f9",
                    isDeadLead
                      ? "#94a3b8"
                      : isOverdueFollowup
                        ? "#991b1b"
                        : "#475569",
                  ),
                  fontSize: 9.5,
                  gap: 3,
                }}
              >
                <FaMapMarkerAlt size={8} /> {item.city_name}
              </span>
            )}
            {item?.followup_date_time && (
              <span
                style={{
                  ...pill(
                    isDeadLead
                      ? "rgba(239, 68, 68, 0.12)"
                      : isOverdueFollowup
                        ? "rgba(239, 68, 68, 0.1)"
                        : "rgba(99, 102, 241, 0.08)",
                    isDeadLead
                      ? "#fca5a5"
                      : isOverdueFollowup
                        ? "#dc2626"
                        : C.info,
                  ),
                  fontSize: 9.5,
                  gap: 3,
                }}
              >
                <FaClock size={8} />
                {formatDateTime(item.followup_date_time)}
              </span>
            )}
          </div>
        </div>

        {/* FOOTER - Compact */}
        <div
          style={{
            padding: "10px 14px 12px",
            borderTop: `1px solid ${isDeadLead || isOverdueFollowup ? "rgba(0,0,0,0.06)" : C.border}`,
            background: theme.footerBg,
          }}
        >
          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 4, marginBottom: 6 }}>
            {/* {[
              {
                label: "Call",
                icon: <FaPhoneAlt size={10} />,
                bg: "linear-gradient(135deg, #10b981, #059669)",
                action: () => onCall(item),
              },
              {
                label: "WA",
                icon: <FaWhatsapp size={10} />,
                bg: "linear-gradient(135deg, #25D366, #128C7E)",
                action: () => onWhatsapp(item),
              },
            ].map((btn) => (
              <button
                key={btn.label}
                onClick={btn.action}
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 4,
                  padding: "7px 4px",
                  borderRadius: 8,
                  border: "none",
                  background: btn.bg,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 10.5,
                  cursor: "pointer",
                  transition: "all 0.15s",
                  fontFamily: FONT,
                }}
              >
                {btn.icon}
                {btn.label}
              </button>
            ))} */}
            <Link
              to={`/dashboard/lead-logs/${Number(item?.id)}`}
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                padding: "7px 4px",
                borderRadius: 8,
                background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                color: "#fff",
                fontWeight: 600,
                fontSize: 10.5,
                textDecoration: "none",
                transition: "all 0.15s",
              }}
            >
              <FaClipboardList size={10} /> Logs
            </Link>
          </div>
 
        </div>
      </div>
 
      <Modal show={showPdf} onHide={handleClosePdf} size="lg" centered>
        <Modal.Header
          closeButton
          style={{
            color: "#000",
            borderBottom: "2px solid #334155",
          }}
        >
          <Modal.Title
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <FaFilePdf size={16} /> View Quotation PDF
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="p-0"
          style={{ maxHeight: "70vh", overflow: "auto" }}
        >
          {renderPdfComponent()}
        </Modal.Body>
      </Modal>

 
    </>
  );
};

export default LeadCard;